import React from 'react';
import { X, Flame, Trophy, MapPin, Car, Map } from 'lucide-react';

export const WelcomeModal = ({ onClose, onExit }) => {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">

        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-6 relative flex-shrink-0">
          <button
            onClick={onExit}
            className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-lg transition-colors"
            aria-label="Zamknij"
          >
            <X size={24} />
          </button>
          <h1 className="text-3xl font-black mb-2">Witaj w MotoRadar24! 👋</h1>
          <p className="text-blue-100">Polska społeczność motoryzacyjna</p>
        </div>

        {/* NOWOŚCI BANNER — Live Mapa */}
        <a
          href="https://mapa.motoradar24.pl"
          target="_blank"
          rel="noopener noreferrer"
          className="block flex-shrink-0 relative overflow-hidden group"
        >
          {/* Screenshot mapy jako tło */}
          <div className="relative h-28 bg-gradient-to-br from-slate-950 via-red-950/60 to-slate-900 flex items-center px-5 gap-4 border-b-2 border-red-500/40">
            {/* Mini SVG dymki animowane */}
            <svg viewBox="0 0 200 80" className="absolute inset-0 w-full h-full opacity-30" preserveAspectRatio="xMidYMid slice">
              <circle cx="40" cy="30" r="8" fill="#E8231C" opacity="0.8"/>
              <circle cx="40" cy="30" r="14" fill="#E8231C" opacity="0.2"/>
              <circle cx="80" cy="50" r="6" fill="#E8231C" opacity="0.7"/>
              <circle cx="120" cy="25" r="10" fill="#E8231C" opacity="0.9"/>
              <circle cx="120" cy="25" r="18" fill="#E8231C" opacity="0.15"/>
              <circle cx="160" cy="55" r="5" fill="#E8231C" opacity="0.6"/>
              <circle cx="100" cy="60" r="4" fill="#FFB800" opacity="0.8"/>
              <circle cx="60" cy="65" r="3" fill="#E8231C" opacity="0.5"/>
              <circle cx="150" cy="35" r="4" fill="#E8231C" opacity="0.6"/>
            </svg>

            {/* Lewa strona — ikona */}
            <div className="relative z-10 flex-shrink-0 w-14 h-14 rounded-xl bg-red-600/20 border border-red-500/40 flex items-center justify-center">
              <Map size={28} className="text-red-400"/>
            </div>

            {/* Środek — tekst */}
            <div className="relative z-10 flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-white font-black text-lg leading-tight">LIVE Mapa Chamstwa</span>
                <span className="flex items-center gap-1 text-[10px] font-bold bg-red-600 text-white px-2 py-0.5 rounded-full flex-shrink-0">
                  <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
                  LIVE
                </span>
              </div>
              <p className="text-gray-300 text-sm leading-tight">214 zgłoszeń z 58 miast Polski — kliknij żeby zobaczyć gdzie jest najgorzej</p>
              <p className="text-red-400 text-xs font-semibold mt-1">mapa.motoradar24.pl →</p>
            </div>
          </div>
        </a>

        {/* Content - scrollable */}
        <div className="p-6 space-y-5 overflow-y-auto flex-1 min-h-0">

          {/* DZBAN ROKU */}
          <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-xl p-5">
            <div className="flex items-start gap-4">
              <div className="bg-red-500 p-3 rounded-xl flex-shrink-0">
                <Flame size={28} className="text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-black text-gray-900 mb-2 flex items-center gap-2">
                  🔥 NOWOŚĆ: Dzban Roku 2026!
                  <span className="text-xs bg-red-500 text-white px-2 py-1 rounded-full animate-pulse">NEW</span>
                </h3>
                <p className="text-sm text-gray-700 mb-3">
                  Społeczne, <strong>satyryczne</strong> głosowanie na najgorsze zachowania drogowe!
                  Głosuj na chamstwo parkingowe, blokerów i innych dzbanów.
                </p>
                <div className="grid grid-cols-3 gap-2 text-xs">
                  <div className="bg-white rounded-lg p-2 text-center">
                    <Trophy size={16} className="mx-auto mb-1 text-amber-500" />
                    <div className="font-bold">TOP 5</div>
                    <div className="text-gray-500">Spotów</div>
                  </div>
                  <div className="bg-white rounded-lg p-2 text-center">
                    <MapPin size={16} className="mx-auto mb-1 text-blue-500" />
                    <div className="font-bold">Miasta</div>
                    <div className="text-gray-500">Ranking</div>
                  </div>
                  <div className="bg-white rounded-lg p-2 text-center">
                    <Car size={16} className="mx-auto mb-1 text-slate-600" />
                    <div className="font-bold">Marki</div>
                    <div className="text-gray-500">Ranking</div>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-3 italic">
                  * Funkcja ma charakter rozrywkowy i edukacyjny. Wyniki nie mają charakteru prawnego.
                </p>
              </div>
            </div>
          </div>

          {/* Główne funkcje */}
          <div>
            <h3 className="font-bold text-lg mb-3 text-gray-900">🚗 Co możesz robić?</h3>
            <div className="space-y-3">
              <div className="flex gap-3 items-start">
                <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0"><MapPin size={20} className="text-blue-600" /></div>
                <div>
                  <div className="font-bold text-sm text-gray-900">Baza Spotów</div>
                  <div className="text-xs text-gray-600">Dodawaj zdjęcia ciekawych pojazdów z całej Polski</div>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="bg-amber-100 p-2 rounded-lg flex-shrink-0"><Trophy size={20} className="text-amber-600" /></div>
                <div>
                  <div className="font-bold text-sm text-gray-900">Exclusive Garage</div>
                  <div className="text-xs text-gray-600">Galeria rzadkich i luksusowych aut</div>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="bg-red-100 p-2 rounded-lg flex-shrink-0"><Flame size={20} className="text-red-600" /></div>
                <div>
                  <div className="font-bold text-sm text-gray-900">Alert Zone</div>
                  <div className="text-xs text-gray-600">Ostrzeżenia o podejrzanych pojazdach (kradzieże, oszustwa)</div>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="bg-emerald-100 p-2 rounded-lg flex-shrink-0"><Car size={20} className="text-emerald-600" /></div>
                <div>
                  <div className="font-bold text-sm text-gray-900">Marketplace</div>
                  <div className="text-xs text-gray-600">Bezpłatne ogłoszenia kupna/sprzedaży aut</div>
                </div>
              </div>
            </div>
          </div>

          {/* Ważne zasady */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
            <h3 className="font-bold text-sm mb-2 text-gray-900">⚠️ Ważne zasady:</h3>
            <ul className="text-xs text-gray-700 space-y-1">
              <li>✅ <strong>Jedna tablica = jeden post</strong> – duplikaty są blokowane</li>
              <li>✅ <strong>Zamazuj twarze</strong> – publikowanie wizerunków bez zgody jest zabronione</li>
              <li>✅ <strong>Szanuj prywatność</strong> – nie publikuj danych osobowych</li>
              <li>✅ <strong>Bądź kulturalny</strong> – bez mowy nienawiści i przemocy</li>
            </ul>
          </div>

          {/* Anonimowość */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
            <h3 className="font-bold text-sm mb-2 text-gray-900">🔒 Pełna anonimowość</h3>
            <p className="text-xs text-gray-700">
              Nie zbieramy e-maili ani haseł. Korzystaj z serwisu w pełni anonimowo.
            </p>
          </div>

          {/* Regulamin */}
          <div className="text-center">
            <p className="text-xs text-gray-600">
              Korzystając z serwisu, akceptujesz{' '}
              <a href="/regulamin" target="_blank" className="text-blue-600 hover:underline font-bold">Regulamin</a>
              {' '}oraz zasady opisane powyżej.
            </p>
          </div>
        </div>

        {/* Footer — social media + przyciski */}
        <div className="bg-gray-50 border-t border-gray-200 flex-shrink-0">

          {/* Social media bar */}
          <div className="px-6 pt-4 pb-3 flex items-center justify-center gap-3">
            <span className="text-xs text-gray-500 font-medium">Obserwuj nas:</span>

            {/* X.com */}
            <a
              href="https://x.com/motoradar24"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-black text-white text-xs font-bold px-3 py-1.5 rounded-full hover:bg-gray-800 transition-colors"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.261 5.632 5.903-5.632zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              @motoradar24
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/motoradar24.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-white text-xs font-bold px-3 py-1.5 rounded-full hover:opacity-90 transition-opacity"
              style={{background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)'}}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              @motoradar24.pl
            </a>

            {/* Telegram */}
            <a
              href="https://t.me/motoradar24_pl"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-[#229ED9] text-white text-xs font-bold px-3 py-1.5 rounded-full hover:bg-[#1a8bbf] transition-colors"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
              </svg>
              Telegram
            </a>
          </div>

          {/* Przyciski akcji */}
          <div className="px-4 pb-4 flex gap-3">
            <button
              onClick={onExit}
              className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-300 transition-all"
            >
              Wyjdź
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg"
            >
              Rozumiem, wchodzę! 🚀
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};